module.exports = __webpack_public_path__ + "img/pic_23.83e25a0e.png";